export default __webpack_public_path__ + "static/media/watchman.5c1d5cf9.svg";